import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import { useAmbossEmbed } from './useAmbossEmbed';

export function AmbossEmbed({
  url,
  reloadToken,
  title,
  onCid,
}: {
  url: string;
  reloadToken?: number;
  title?: string;
  onCid?: (cid: string) => void;
}) {
  const { t } = useTranslation();
  const { mechanism, status, retry, frameKey, iframeRef, webviewRef, webviewSrc, canLoadWebview } =
    useAmbossEmbed({ url, reloadToken, onCid });

  if (status === 'error') {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-6 text-center">
        <p className="text-sm text-foreground">{t('amboss.embed.error')}</p>
        <Button onClick={retry}>{t('amboss.embed.retry')}</Button>
      </div>
    );
  }

  return (
    <div className="relative h-full w-full">
      {status === 'loading' && (
        <div className="absolute inset-0 flex items-center justify-center bg-background">
          <p className="text-sm text-muted-foreground">{t('amboss.embed.loading')}</p>
        </div>
      )}
      {mechanism === 'webview' ? (
        canLoadWebview && (
          <webview
            ref={webviewRef}
            key={frameKey}
            src={webviewSrc}
            title={title ?? t('amboss.searchPanel.title')}
            className="h-full w-full border-0"
            data-ph-no-autocapture
          />
        )
      ) : (
        <iframe
          ref={iframeRef}
          key={frameKey}
          title={title ?? t('amboss.searchPanel.title')}
          src={url}
          className="h-full w-full border-0"
          data-ph-no-autocapture
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          referrerPolicy="no-referrer"
        />
      )}
    </div>
  );
}
